export const allowedTags = [
    'strong',
    'div',
    'iframe',
    'a',
    'img',
    'br',
    'p',
    'ul',
    'ol',
    'li',
    'em',
    's',
    'u',
    'span',
];
